import "../../../shared/utilities/detect_transition.js";

// Shows a preview of what the page looks like at various device layouts
jQuery(function () {
  var iframe = jQuery('[data-behaviour~="device-type-selector"]');

  if (iframe[0] == undefined) {
    return;
  }

  var iframeWindow = iframe[0].contentWindow;
  var transitionEvent = window.Sparkle.Utilities.DetectCssEvent.transition.end();

  var seoParser = new SEOIframeParser();
  var seoPreview = new SEOPreview();
  var modal = new Modal({ class: "seo-preview-modal admin-modal", body: seoPreview.el });

  // BEHAVIOUR

  jQuery(document).on("click", "#sandbox-controls .responsive-icon", resizeAndReloadIframe);
  jQuery(document).on("click", '[data-behaviour~="select-seo-platform"]', handleSeoPlatformSelected);
  jQuery(document).on("headReady", whenIframeIsReady);
  new MutationObserver(handleIframeSrcChange).observe(iframe[0], {
    subtree: false,
    childList: false,
    attributeFilter: ["src"],
  });

  // HANDLE

  function handleIframeSrcChange(mutationList) {
    mutationList.forEach((mutation) => {
      if (mutation.type == "attributes" && mutation.attributeName == "src") {
        updateUrlToMatchIframe();
      }
    });
  }

  // INITIALIZE

  var initialDeviceButton = deviceButtonFor(Sparkle.DevicePreference.get());
  setDeviceType(initialDeviceButton);
  if (initialDeviceButton.data("device-type") !== "unconstrained") {
    waitForAnimationBeforeReload();
  }
  detectIframeHeadReady();

  // HELPER FUNCTIONS

  function handleSeoPlatformSelected(event) {
    seoPreview.setActivePlatform(jQuery(event.currentTarget).data("platform"));
    modal.show();
  }

  function resizeAndReloadIframe(event) {
    Sparkle.DevicePreference.set(jQuery(this).data("device-type"));
    setDeviceType(this);
    waitForAnimationBeforeReload();
  }

  function deviceButtonFor(deviceType) {
    var button = jQuery('#sandbox-controls .responsive-icon[data-device-type="' + deviceType + '"]');
    return button.length ? button : jQuery("#responsive-icon-unconstrained");
  }

  function whenIframeIsReady() {
    // Setup SEO buttons and modal
    setSEOData(iframeWindow.document);

    if (iframe.data("no-url-update")) {
      return;
    }

    var url = new URL(iframe.attr("src"));
    url.host = window.location.host; // If we're on a campaign or other subdomain, we must use the current domain to avoid a browser security exception

    // Set page title to iframe title
    document.title = iframeWindow.document.title;

    // Set the iframe anchor to match the main window so we jump to the correct location
    jQuery(window)
      .on("hashchange", function () {
        iframeWindow.location.hash = window.location.hash;
      })
      .trigger("hashchange");

    // Update the url bar to match the url of the preview
    updateUrlToMatchIframe(url);

    // Add base link properties to mask the fact that we're in an iframe
    var baseElement = jQuery("<base>");
    baseElement.attr("href", url.href); // Make sure relative anchors use the preview url, not the url we posted changes to during a rehearsal
    baseElement.attr("target", "_parent"); // Make sure iframe links reload the entire window
    jQuery(iframeWindow.document).find("head").append(baseElement);

    jQuery(iframeWindow.document).on("click", 'a[href^="#"]', function () {
      var target = iframeWindow.document.getElementById(this.hash.slice(1));
      if (window.location.hash == this.hash && target) {
        target.scrollIntoView();
      }
    });
  }

  function updateUrlToMatchIframe(url = iframe.attr("src")) {
    window.history.replaceState(null, iframeWindow.title, url);
  }

  function setSEOData(iFrameContext) {
    seoParser.setContext(iFrameContext);
    seoPreview.update(seoParser.getData());
  }

  function setDeviceType(element) {
    jQuery(".responsive-icon").removeClass("active");
    jQuery(element).addClass("active");
    jQuery("#device").attr("data-type", jQuery(element).data("device-type"));
  }

  // We wait for element to finish its transiton before we reload the iframe
  // Reason being is the width is still changing during the animation and it needs
  // to be stopped, so that width specific events will fire once the reload happens
  function waitForAnimationBeforeReload() {
    jQuery("#device").one(transitionEvent, reloadFrame);
  }

  // Reload iFrame and reattach events to new document
  function reloadFrame() {
    iframe.attr("srcdoc", iframe.attr("srcdoc"));
    detectIframeHeadReady();
  }

  function detectIframeHeadReady() {
    var content;
    var interval = setInterval(function () {
      content = iframeWindow.document.querySelectorAll("body > *");
      if (content.length) {
        Sparkle.PreviewViewportScrollbar.apply(iframeWindow.document, jQuery("#device").attr("data-type"));

        clearInterval(interval);
        iframe.trigger("headReady");
      }
    }, 10);
  }
});
